import { removeSpacesFromString } from "./writingLabelRule"

export const truncateString = (value: string, maxLength: number) => {
  if (value && value.length <= maxLength) {
    return value
  }
  return value ? value.substring(0, maxLength - 5) + "[...]" : ""
}

export const croppedString = (name: string, maxLength: number) => {
  if (name && name.length > maxLength) {
    const croppedName =
      name.substring(0, Math.floor(maxLength / 2 - 1)) +
      "..." +
      name.substring(name.length - Math.ceil(maxLength / 2 + 1), name.length)
    name = croppedName
  }
  return name
}

export const croppedEndString = (name: string, maxLength: number) => {
  if (name.length > maxLength) {
    return name.slice(0, maxLength) + "..."
  }
  return name
}

export function normalizeString(str: string) {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replaceAll(/\p{Diacritic}/gu, "")
    .replaceAll("’", "'")
}

export const fileExtensionOfString = (fileName: string) => {
  const lastDotPosition = fileName.lastIndexOf(".")

  // .foo does not have extension foo
  // a.foo does have extension foo
  if (lastDotPosition < 1) return null

  return fileName.substring(lastDotPosition + 1, fileName.length).toLowerCase()
}

export const truncateFileName = (value: string, maxLength: number) => {
  if (value.length > maxLength) {
    const extension = value
      .substring(value.lastIndexOf(".") + 1, value.length)
      .toLowerCase()
    let filename = value.replace("." + extension, "")
    if (filename.length <= maxLength) {
      return value
    }
    const renamed =
      filename.substr(0, maxLength) + (value.length > maxLength ? "[...]" : "")
    return renamed + "." + extension
  }
  return value
}

export const Uppercase = (str: string) => {
  return str.toLocaleUpperCase()
}

export function capitalizeFirstLetter(str: string) {
  return str?.length > 0 ? str.charAt(0).toUpperCase() + str.slice(1) : ""
}

export function capitalizeFirstLetters(str: string) {
  return str
    ?.split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
}

export const startsWithVowel = (word: string): boolean => {
  return /^[aeiouAEIOU]/.test(normalizeString(word))
}

export const safeName = (string: string) => {
  if (!string) return ""
  const replaceBy = " "
  const cleaned = cleanNonStandardChars(string, replaceBy)
  return removeDuplicateReplacements(cleaned, replaceBy)
}

export const safeReference = (string: string) => {
  if (!string) return ""
  const replaceBy = "_"
  const cleaned = cleanNonStandardChars(string, replaceBy)
  const noSpaces = removeSpacesFromString(cleaned)
  return removeDuplicateReplacements(noSpaces, replaceBy)
}

export const removeDuplicateReplacements = (
  string: string,
  replaceBy: string
) => {
  if (!string) return ""
  string = string
    .replace(new RegExp(`${replaceBy}{2,}`, "g"), replaceBy)
    .replace(new RegExp(`^${replaceBy}`), "")
    .replace(new RegExp(`${replaceBy}$`), "")
    .replace(new RegExp(` ${replaceBy} `, "g"), " ")
    .replace(new RegExp(`${replaceBy} `, "g"), " ")
    .replace(new RegExp(` ${replaceBy}`, "g"), " ")
    .trim()

  if (replaceBy === "_") {
    string = string
      .replace(new RegExp(`-${replaceBy}-`, "g"), "-")
      .replace(new RegExp(`${replaceBy}-`, "g"), "-")
      .replace(new RegExp(`-${replaceBy}`, "g"), "-")
  }

  return string
}

export const cleanNonStandardChars = (string: string, replaceBy: string) => {
  if (!string) return ""

  const nonStandardChars =
    "@ÀÁÂÃÄÅàáâãäåĀāĂăĄąÇçĆćĈĉĊċČčÐðĎďĐđ€ÈÉÊËèéêëĒēĔĕĖėĘęĚěĜĝĞğĠġĢģĤĥĦħÌÍÎÏìíîïĨĩĪīĬĭĮįİıĴĵĶķĸĹĺĻļĽľĿŀŁłÑñŃńŅņŇňŉŊŋÒÓÔÕÖØòóôõöøŌōŎŏŐőŔŕŖŗŘřŚśŜŝŞşŠšȘșſŢţŤťŦŧȚțÙÚÛÜùúûüŨũŪūŬŭŮůŰűŲųŴŵÝýÿŶŷŸŹźŻżŽžАаБбВвДдЕеЀѐЁёЄєЗзЅѕІіЇїЈјКкМмНнОоРрСсТтЌќУуӮӯЎўХхЦцЏџШшЩщЪЬьi̇"
  const replacementChars =
    "AAAAAAAaaaaaaAaAaAaCcCcCcCcCcDdDdDdEEEEEeeeeEeEeEeEeEeGgGgGgGgHhHhIIIIiiiiIiIiIiIiIiJjKkkLlLlLlLlLlNnNnNnNnnNnOOOOOOooooooOoOoOoRrRrRrSsSsSsSsSssTtTtTtTtUUUUuuuuUuUuUuUuUuUuWwYyyYyYZzZzZzAa66BBAAEeEeEeEe33SsIiIiJjKkMMHHOoPpCcTtKkYyyyYyXxUuUuWwWwbbbi"

  const cleaned = string
    .split("")
    .map((char) => {
      const index = nonStandardChars.indexOf(char)
      return index !== -1 ? replacementChars[index] : char
    })
    .join("")

  return cleaned.replace(/[^a-z0-9 \-.!_,&;:%)(*]/gi, replaceBy)
}
